


























































































































import SeletorDeTipoDeCliente from '@/components/tabeladepreco/SeletorDeTipoDeCliente.vue'
import DatePicker from '@/components/ui/DatePicker.vue'
import { FormaDePagamento, SituacaoDoTitulo } from '@/models'
import type { FiltroDeTitulos } from '@/models'
import { limparFiltroDosCamposDeTitulos } from '@/shareds/titulo-shareds'
import { nextTick } from '@/shareds/utils'
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import SeletorDeAdquirente from '@/views/application/venda/SeletorDeAdquirente.vue'


@Component({
	components: {
		DatePicker,
		SeletorDeTipoDeCliente,
		SeletorDeAdquirente,
	},
})
export default class CamposDeFiltrosDeTitulos extends Vue {
	@Prop({ type: Boolean, default: false }) carregando!: boolean
	@PropSync('value', {
		default: () => ({
			tipoDeCliente: '',
			pessoa: '',
			dataInicioPeriodo: [],
			dataFimPeriodo: [null, null],
			situacaoDoTitulo: '',
			formaDePagamento: false,
			loja: '',
			numeroDocumento: false,
			dataInicioPagamento: null,
			dataFimPagamento: null,
			numeroDoCheque: false,
		}),
	})
	filtro!: FiltroDeTitulos

	mostra: boolean | null = null

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Voucher',
		'Crediário',
		'Link',
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
		'Outros',
		'Cheque',
		'Boleto',
		'Pix',
	]

	opcoesDeSituacaoDeTitulo: SituacaoDoTitulo[] = [
		'Aberto',
		'Pago',
		'Cancelado',
		'Estornado',
	]

	mostrar() {
		this.mostra = true
	}

	ocultar() {
		this.mostra = false
	}

	async aplicarFiltro() {
		if(!this.validaFiltroDeDataPagamento) return

		await nextTick()
		this.$emit('buscar', this.filtro)
		this.ocultar()
	}

	limparFiltros() {
		this.$emit('limpar')
		this.$emit('input', limparFiltroDosCamposDeTitulos())
	}

	get validaFiltroDeDataPagamento() {
		if ((this.filtro.dataInicioPagamento && !this.filtro.dataFimPagamento) || 
			(!this.filtro.dataInicioPagamento && this.filtro.dataFimPagamento))
		{
			return { isValid: false, message: 'Necessário adicionar ambas as datas' };
		} else {
			return { isValid: true };
		}
	}
}
